<template>
  <div class="c-label-component">
    <component :is="htmlElement" class="c-label-component__html-element" :for>
      {{ label }}
    </component>

    <span v-if="required" class="c-label-component__required">Verplicht</span>

    <c-badge v-if="badge" :label="badge" />

    <c-tooltip-standalone v-if="tooltip" size="xs"
      >{{ tooltip }}
    </c-tooltip-standalone>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  tooltip: {
    type: [String, null],
    default: () => "",
  },
  badge: {
    type: [String, null],
    default: () => null,
  },
  for: {
    type: [String, null],
    default: () => null,
  },
  required: {
    type: Boolean,
    default: () => false,
  },
});

const htmlElement = computed(() => {
  const { for: _for = null } = props || {};

  return _for ? "label" : "span";
});
</script>

<style lang="scss" scoped>
.c-label-component {
  @apply tw-flex tw-items-center tw-gap-2;

  &__html-element {
    @apply tw-block tw-font-medium;
  }

  &__required {
    @apply tw-ml-auto tw-self-center tw-text-xs tw-text-gray-500;
  }
}
</style>
